module.exports = __webpack_public_path__ + "img/select-light-02.c045d058.png";